import { useEffect, useState } from 'react'

import api from 'common/api'
import { DEFAULT_MIN_PASSWORD_LENGTH } from 'common/password-validation'

type PasswordRequirements = {
  minPasswordLength: number
}

export type PasswordRequirementsError = 'invalid' | 'server' | null

type UsePasswordRequirementsResult = {
  minLength: number
  loading: boolean
  error: PasswordRequirementsError
}

export const usePasswordRequirements = (userId?: string, confirmCode?: string): UsePasswordRequirementsResult => {
  const [minLength, setMinLength] = useState(DEFAULT_MIN_PASSWORD_LENGTH)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<PasswordRequirementsError>(null)

  useEffect(() => {
    if (!userId || !confirmCode) {
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    api
      .get<PasswordRequirements>(
        `/api/user/password/requirements/${encodeURIComponent(userId)}/${encodeURIComponent(confirmCode)}`,
      )
      .then((res) => {
        setMinLength(res.minPasswordLength)
      })
      .catch((err) => {
        const status = err?.status || err?.statusCode
        if (status === 401 || status === 404) {
          setError('invalid')
        } else {
          setError('server')
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [userId, confirmCode])

  return { minLength, loading, error }
}
